module.exports = __webpack_public_path__ + "img/banner_search.4c6f6c34.png";